import { Logger } from "../../helpers/Logger";
import { EVENTS } from "../config/CONSTANTS";

/**
* @fileoverview Handles tracking events with InMarket Pixel.
* @module InMarketPixel
*/

/**
* Tracks an event and sends data to InMarket Pixel.
* Initializes the pixel if not already initialized.
*
* ### Allowed Event Types
* - Common event types: `PageVisit`, `Conversion`, or custom events (e.g., 'view-content').
* - `eventData` is currently unused by InMarket but included for consistency.
*
* @example
* trackInMarketEvent('PageVisit');
* trackInMarketEvent('conversion');
*
* @param {string} eventType - The type of event to track.
* @param {Object} [eventData] - Optional data (currently unused by InMarket).
*/
export function trackInMarketEvent(eventType, eventData = {}) {
  if (typeof window === "undefined") return;

  // Initialize InMarket pixel if not already loaded
  if ( !window.inMarket ) {
    // Load the InMarket script dynamically
    const script = document.createElement("script");
    script.src = "https://scripts.inmarkethub.com/conversion-tracking/v1.js";
    script.id = "inmarket-script";
    script.type = "application/javascript";
    script.async = true;

    script.onload = () => Logger.log("InMarket Pixel script loaded successfully");
    script.onerror = () => Logger.error("Failed to load InMarket Pixel script");

    document.head.appendChild(script);
  }

  // If the inMarket script is loaded, send the event if it's a conversion and not a page view
  if ( window.inMarket && eventType !== EVENTS.PageView ) {
    window.inMarket.trackConversion(eventType);
    Logger.log(`InMarket Pixel event sent: ${eventType}`);
  } else if ( eventType !== EVENTS.PageView ) {
    Logger.error(`Error tracking InMarket event: ${eventType}`);
  }
}